// extracted by mini-css-extract-plugin
export default {"IsrCard":"IsrCard_IsrCard__75igJ"};